<div style="margin: 40px 20px;">
	<div style="display: flex; flex-flow: column nowrap; gap: 40px; align-items: center; margin: 0 auto; max-width: 800px;">

		@if( chatApprovalStep == ChatApprovalStep.terms ) {

			<div class="textContainer">

				<div class="title1">
					Nutzungsbedingungen für den Chat im Mitgliederportal
				</div>

				@if( bLoading ) {
					<mat-spinner diameter="30" />
				}
				@else if( bErrorLoading ) {
					<div class="errorWarning">
						Beim Laden der Daten ist ein Fehler aufgetreten
					</div>
				}
				@else {
					<div [innerHTML]="termsOfUseChatHtml"></div>
				}

			</div>

			<div class="textContainer">
		
				<div class="title1">
					Datenschutzerklärung für den Chat im Mitgliederportal
				</div>

				@if( bLoading ) {
					<mat-spinner diameter="30" />
				}
				@else if( bErrorLoading ) {
					<div class="errorWarning">
						Beim Laden der Daten ist ein Fehler aufgetreten
					</div>
				}
				@else {
					<div [innerHTML]="privacyPolicyChatHtml"></div>
				}

			</div>
			

			<mat-checkbox
				(change)="updateCheck($event.checked)"
				[disabled]="bLoading || bErrorLoading"
			>
				Hiermit stimme ich den Nutzungsbedingungen und den ergänzenden Datenschutzerklärungen zu.
			</mat-checkbox>
		
			<button
				mat-raised-button
				(click)="clickApprove()"
				[disabled]="bInProgress || !bTermsApproved || bLoading || bErrorLoading"
			>
				OK
			</button>
		
			@if( bError ) {
				<div class="errorWarning">
					Beim Akzeptieren der Bedingungen ist ein Fehler aufgetreten
				</div>
			}

		}
		@else if( chatApprovalStep == ChatApprovalStep.nameCheck ) {

			<div class="aSubTitle">
				Vor- und Nachname
			</div>
			
			<div>
				Bevor Sie den Chat starten, können Sie den Vor- und Nachnamen überprüfen, der Ihrem Benutzerkonto zugewiesen ist.
			</div>

			<div style="display: flex; flex-flow: row wrap; gap: 30px">
				<triv-input
					[fGroup]="formGroup"
					[data]="myInputs.ebeVorname"
					style="flex-grow: 1;"
				/>
				<triv-input
					[fGroup]="formGroup"
					[data]="myInputs.ebeName"
					style="flex-grow: 1;"
				/>
			</div>

			<button
				mat-raised-button
				(click)="clickSaveName()"
				[disabled]="bInProgress"
			>
				OK
			</button>
		
			@if( bError ) {
				<div class="errorWarning">
					Beim Speichern des Vor- und Nachnamens ist ein Fehler aufgetreten
				</div>
			}

		}
		@else {
			ERROR
		}

	</div>
</div>
